<template>
  <div>
    <ComplexLibraryWrite v-if="fieldCode === 'library'" />
    <ComplexMuseumWrite v-else-if="fieldCode === 'museum'" />
    <ComplexMedicalWrite v-else-if="fieldCode === 'medical'" />
    <ComplexDaycareWrite v-else-if="fieldCode === 'daycare'" />
    <ComplexOfficeWrite v-else-if="fieldCode === 'office'" />
    <ComplexIndoorAuditoriumWrite v-else-if="fieldCode === 'indoor-auditorium'" />
    <ComplexMixedUseBuildingWrite v-else-if="fieldCode === 'mixed-use-building'" />
    <ComplexBuildingWrite v-else-if="fieldCode === 'building'" />
    <FieldFacilityBridgeWrite v-else-if="fieldCode === 'bridge'" />
    <FieldFacilityRetainingWallWrite v-else-if="fieldCode === 'retaining-wall'" />
  </div>
</template>

<script>
import ComplexLibraryWrite from "@/views/_BS/ComplexLibraryWrite.vue";
import ComplexMuseumWrite from "@/views/_BS/ComplexMuseumWrite.vue";
import ComplexMedicalWrite from "@/views/_BS/ComplexMedicalWrite.vue";
import ComplexDaycareWrite from "@/views/_BS/ComplexDaycareWrite.vue";
import ComplexOfficeWrite from "@/views/_BS/ComplexOfficeWrite.vue";
import ComplexIndoorAuditoriumWrite from "@/views/_BS/ComplexIndoorAuditoriumWrite.vue";
import ComplexMixedUseBuildingWrite from "@/views/_BS/ComplexMixedUseBuildingWrite.vue";
import ComplexBuildingWrite from "@/views/_BS/ComplexBuildingWrite.vue";
import FieldFacilityBridgeWrite from "@/views/_BS/FieldFacilityBridgeWrite.vue";
import FieldFacilityRetainingWallWrite from "@/views/_BS/FieldFacilityRetainingWallWrite.vue";

export default {
  name: 'FieldWriteByCode',
  components: {
    FieldFacilityRetainingWallWrite,
    FieldFacilityBridgeWrite,
    ComplexMuseumWrite,
    ComplexBuildingWrite,
    ComplexMixedUseBuildingWrite,
    ComplexIndoorAuditoriumWrite,
    ComplexOfficeWrite,
    ComplexDaycareWrite,
    ComplexMedicalWrite,
    ComplexLibraryWrite,
  },
  computed: {
    fieldCode() {
      return this.$route.params.fieldCode;
    }
  }
};
</script>

<style scoped>

</style>
